import { RouteProps } from "react-router-dom";
import Content from "Types/Content";
import Style from "./style.module.scss";

const Pelotita: React.FC<RouteProps> = () => {
  return (
    <div className={Style.animation}>
      <div className={Style.scene}>
        <div className={Style.floor} />
        <div className={Style.cube}>
          <div className={Style.front} />
          <div className={Style.back} />
          <div className={Style.left} />
          <div className={Style.right} />
          <div className={Style.top}>
            <div className={Style.ballShadow} />
          </div>
          <div className={Style.bottom} />
        </div>
        <div className={Style.ball}>
          <div className={Style.shadowLanded} />
        </div>
      </div>
    </div>
  );
};

export default new Content({
  Component: Pelotita,
  title: "Animación 3D CSS-Only",
  route: "pelotita"
});
